export const tradingContent = {
  fr: {
    hero: {
      title: "Commerce International",
      subtitle: "Flux Commerciaux Stratégiques",
      description: "Skymoon opère activement dans le commerce international, connectant producteurs et marchés à travers les continents avec des partenariats stratégiques et notre marque propre."
    },
    brands: {
      label: "Notre Marque",
      title: "LINGUITI Tomato",
      subtitle: "Marque Propre — Double Concentré de Tomates",
      desc: "LINGUITI Tomato est la marque propre de Skymoon, distribuée en Afrique de l'Ouest. Produite en partenariat avec un producteur industriel certifié FDA, BRC, HACCP et Halal.",
      details: [
        { label: "Format", value: "800g / 400g" },
        { label: "Concentration", value: "28-30%" },
        { label: "Certifications", value: "FDA · BRC · Halal" },
        { label: "Marchés", value: "Mauritanie, Côte d'Ivoire" }
      ],
      imgLabel: "Container Linguiti Tomato prêt à l'export"
    },
    partners: {
      label: "Partenaires Commerciaux",
      title: "Nos Partenariats Stratégiques",
      subtitle: "Un réseau international de producteurs et distributeurs de confiance.",
      items: [
        {
          name: "Lollo Caffè",
          country: "Italie",
          category: "Café Premium",
          desc: "Partenariat avec la maison italienne Lollo Caffè, torréfacteur historique de Naples, pour la valorisation de nos cafés d'origine Congo et Côte d'Ivoire sur le marché italien.",
          flag: "IT"
        }
      ]
    },
    activities: {
      label: "Nos Activités",
      title: "Flux Commerciaux Actifs",
      subtitle: "Des opérations commerciales structurées entre continents.",
      items: [
        {
          title: "Café Premium",
          route: "Congo, Côte d'Ivoire → Italie",
          desc: "Export de café de haute qualité vers les torréfacteurs italiens, dont Lollo Caffè.",
          status: "Actif"
        },
        {
          title: "LINGUITI Tomato",
          route: "Chine → Mauritanie, Côte d'Ivoire",
          desc: "Double concentré de tomates sous notre marque propre LINGUITI, production Tianjin Shinhoo.",
          status: "Actif"
        },
        {
          title: "Huile de Tournesol",
          route: "Russie → Afrique de l'Ouest",
          desc: "Distribution d'huile de tournesol pour les marchés mauritaniens et ivoiriens.",
          status: "Actif"
        },
        {
          title: "Huile de Palme",
          route: "Malaisie, Indonésie → Mauritanie, Côte d'Ivoire",
          desc: "Approvisionnement en huile de palme de qualité depuis l'Asie du Sud-Est.",
          status: "Actif"
        },
        {
          title: "Lait en Poudre Entier",
          route: "Pologne → Dakar",
          desc: "Négociation en cours pour l'approvisionnement du marché sénégalais en lait entier (25kg) depuis une coopérative laitière européenne majeure.",
          status: "En négociation"
        }
      ]
    },
    projects: {
      label: "Projets en Développement",
      title: "Initiatives en Cours",
      subtitle: "Des projets stratégiques en phase de structuration.",
      items: [
        {
          title: "Subventions Engrais",
          desc: "Programme de subvention d'engrais pour les agriculteurs sénégalais.",
          status: "En cours"
        },
        {
          title: "Tracteurs Solaires Autonomes",
          desc: "Partenariat avec une entreprise allemande pour le déploiement de tracteurs solaires autonomes.",
          status: "En cours"
        },
        {
          title: "Semences Originelles",
          desc: "Intégration de semences originelles pour retrouver le vrai goût des fruits et légumes.",
          status: "En cours"
        },
        {
          title: "Produits Agricoles",
          desc: "Commercialisation de produits destinés à l'agriculture durable.",
          status: "En cours"
        }
      ]
    },
    back: "Retour à l'accueil"
  },
  en: {
    hero: {
      title: "International Trade",
      subtitle: "Strategic Trade Flows",
      description: "Skymoon actively operates in international trade, connecting producers and markets across continents with strategic partnerships and our own brand."
    },
    brands: {
      label: "Our Brand",
      title: "LINGUITI Tomato",
      subtitle: "Own Brand — Double Concentrated Tomato Paste",
      desc: "LINGUITI Tomato is Skymoon's own brand, distributed in West Africa. Produced in partnership with an industrial producer certified FDA, BRC, HACCP and Halal.",
      details: [
        { label: "Format", value: "800g / 400g" },
        { label: "Concentration", value: "28-30%" },
        { label: "Certifications", value: "FDA · BRC · Halal" },
        { label: "Markets", value: "Mauritania, Ivory Coast" }
      ],
      imgLabel: "Linguiti Tomato container ready for export"
    },
    partners: {
      label: "Trade Partners",
      title: "Our Strategic Partnerships",
      subtitle: "An international network of trusted producers and distributors.",
      items: [
        {
          name: "Lollo Caffè",
          country: "Italy",
          category: "Premium Coffee",
          desc: "Partnership with Italian house Lollo Caffè, historic Naples roaster, to promote our Congo and Ivory Coast origin coffees on the Italian market.",
          flag: "IT"
        }
      ]
    },
    activities: {
      label: "Our Activities",
      title: "Active Trade Flows",
      subtitle: "Structured commercial operations between continents.",
      items: [
        {
          title: "Premium Coffee",
          route: "Congo, Ivory Coast → Italy",
          desc: "Export of high-quality coffee to Italian roasters, including Lollo Caffè.",
          status: "Active"
        },
        {
          title: "LINGUITI Tomato",
          route: "China → Mauritania, Ivory Coast",
          desc: "Double concentrated tomato paste under our own LINGUITI brand, produced by Tianjin Shinhoo.",
          status: "Active"
        },
        {
          title: "Sunflower Oil",
          route: "Russia → West Africa",
          desc: "Distribution of sunflower oil for Mauritanian and Ivorian markets.",
          status: "Active"
        },
        {
          title: "Palm Oil",
          route: "Malaysia, Indonesia → Mauritania, Ivory Coast",
          desc: "Quality palm oil supply from Southeast Asia.",
          status: "Active"
        },
        {
          title: "Full Cream Milk Powder",
          route: "Poland → Dakar",
          desc: "Negotiation ongoing to supply the Senegalese market with full cream milk powder (25kg) from a major European dairy cooperative.",
          status: "Negotiation"
        }
      ]
    },
    projects: {
      label: "Projects in Development",
      title: "Ongoing Initiatives",
      subtitle: "Strategic projects in structuring phase.",
      items: [
        {
          title: "Fertilizer Subsidies",
          desc: "Fertilizer subsidy program for Senegalese farmers.",
          status: "Ongoing"
        },
        {
          title: "Autonomous Solar Tractors",
          desc: "Partnership with a German company for autonomous solar tractor deployment.",
          status: "Ongoing"
        },
        {
          title: "Original Seeds",
          desc: "Integration of original seeds to rediscover the true taste of fruits and vegetables.",
          status: "Ongoing"
        },
        {
          title: "Agricultural Products",
          desc: "Marketing of products for sustainable agriculture.",
          status: "Ongoing"
        }
      ]
    },
    back: "Back to Home"
  }
};
